class Moderation.Routers.moderation_dashboard extends Backbone.Router
  initialize: (options) ->

  routes:
    "index": "index"
    ".*": "index"

  index: =>
    @view = new Moderation.Views.DashboardView().render()
